var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRocket = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "currentColor",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2879 9.9064c-3.9156 4.3932-6.6605 10.1292-6.91 10.724l-6.2184-1.765c-1.2476-.5372-1.5547-2.1678-.595-3.127L8.342 9.9639c.9022-.9017 2.2074-1.3046 3.4742-1.0552zm.922 19.0116c.5759.5755 1.4204.729 2.1498.3837 2.2266-1.036 7.006-3.4724 10.0963-6.5611 8.8103-8.8056 8.8871-15.9805 8.3689-19.05a1.879 1.879 0 0 0-1.5164-1.5156c-3.0711-.518-10.2499-.4412-19.0602 8.3644-3.0903 3.0887-5.5088 7.8656-6.5645 10.091-.3455.729-.1728 1.5923.3839 2.1486zm12.8981-5.1989c-4.3955 3.9136-10.9217 6.6569-11.5167 6.9063l2.5535 6.2157c.5374 1.247 2.169 1.5539 3.1287.5947l5.7776-5.7745c.9021-.9016 1.3052-2.2062 1.0557-3.4723zm-8.445-9.2085c0-2.1103 1.7276-3.8369 3.839-3.8369s3.8389 1.7266 3.8389 3.8369c0 2.1102-1.7275 3.8368-3.8389 3.8368s-3.839-1.7266-3.839-3.8368m-7.7779 14.4507a5.09 5.09 0 0 1-.1193 2.4765 5.096 5.096 0 0 1-1.2744 2.1271c-1.3087 1.308-5.3708 2.2763-8.0053 2.7859-1.1727.2209-2.2095-.8154-1.9886-1.9875.51-2.633 1.4617-6.693 2.7875-8.001a5.1 5.1 0 0 1 4.606-1.393c1.9885.3737 3.6202 2.0045 3.9941 3.992"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRocket);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rocket.9ca3f67f28c6907b9b9f7472d4ebcc73.svg";